module.exports = __webpack_public_path__ + "static/media/flag(en).2a56120c.svg";